import React from "react";
import MulTransaction from "../components/mulecules/transaction/mul-transaction";

function Transactios() {
    return(<MulTransaction/>)
}

export default Transactios